module.exports = __webpack_public_path__ + "img/eye.bd88c81b.svg";